import React, { useEffect, useState } from 'react';
import './DonorRoomDisplay.css';

const DonorRoomDisplay = () => {
  const [lastUpdated, setLastUpdated] = useState(new Date());
  const [donors, setDonors] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchDonors();

    const refreshInterval = setInterval(() => {
      fetchDonors();
    }, 20000);

    const clockInterval = setInterval(() => {
      setLastUpdated(new Date());
    }, 60000);

    return () => {
      clearInterval(refreshInterval);
      clearInterval(clockInterval);
    };
  }, []);

  const fetchDonors = async () => {
    try {
      const response = await fetch('https://hospital.rozeetechnist.com/hospital-api/getDonorsList.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({})
      });

      const result = await response.json();
      if (result.status) {
        setDonors(result.data || []);
      } else {
        setDonors([]);
      }
    } catch (error) {
      console.error('Error fetching donors:', error);
      setDonors([]);
    } finally {
      setIsLoading(false);
    }
  };

  const formatMultiline = (text) => {
    if (!text) return '';
    return text.replace(/\\n/g, '\n');
  };

  const slidingDonors = donors.length > 0 ? [...donors, ...donors] : [];

  // const formatAmount = (amount) => {
  //   return Number(amount).toLocaleString('en-IN', {
  //     maximumFractionDigits: 0,
  //     minimumFractionDigits: 0
  //   });
  // };

  return (
    <div className="donor-room-display">
      <header className="drd-header">
        <h1 className="drd-title">સુમરા હોસ્પિટલ</h1>
        <p className="drd-subtitle">હોસ્પિટલ ના રૂમના દાતાઓ</p>
      </header>

      <main className="drd-content">
        {isLoading ? (
          <div className="drd-empty">
            <div className="drd-empty-icon">⏳</div>
            <h2>Loading...</h2>
          </div>
        ) : donors.length === 0 ? (
          <div className="drd-empty">
            <div className="drd-empty-icon">🙏</div>
            <h2>No Donors Yet</h2>
            <p>Thank you for your support!</p>
          </div>
        ) : (
          <div className="drd-slider">
            <div className="drd-track">
              {slidingDonors.map((donor, index) => (
                <div
                  key={`${donor.id}-${index}`}
                  className="drd-card"
                >
                  <div className="drd-name-row">
                  <div className="drd-name">
                    <span className="drd-name-text">{formatMultiline(donor.name)}</span>
                    {donor.company ? (
                      <span className="drd-company"> · {donor.company}</span>
                    ) : null}
                  </div>
                    <span className="drd-city-badge">{donor.city}</span>
                  </div>
                  <div className="drd-row">
                    <span className="drd-label">Amount</span>
                    <span className="drd-value drd-value-strong">₹{donor.amount}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </main>

      <footer className="drd-footer">
        Last updated: {lastUpdated.toLocaleTimeString()}
      </footer>
    </div>
  );
};

export default DonorRoomDisplay;
